import { createFileRoute } from '@tanstack/react-router';
import { WriteoffDetailPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/writeoffs/$id')({
  component: function WriteoffRoute() {
    const { id } = Route.useParams();
    return <WriteoffDetailPage id={id} />;
  },
});
